exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".required-field-missing[data-v-f8a1e504] {\n  background: #f78580;\n}\n", ""]);

// exports
